export default __webpack_public_path__ + "media/zurb/img/home/firefox-logo-189e086d41ba66ceb8e1e0abdf51f659.png";